import React, { useRef, useState, useEffect } from 'react';
import './UploadOwnerRecording.css';
import FadeLoader from "react-spinners/FadeLoader";
const MAX_SIZE = 200 * 1024 * 1024; // 200MB

const UploadOwnerRecording = ({ open, onClose, onSave, showReplace, existingFile,loader }) => {
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState('');
    const [showSuccess, setShowSuccess] = useState(showReplace);
    const ACCEPTED_TYPES = ['video/mp4', 'video/quicktime'];



    useEffect(() => {
        if (open) {
            if (showReplace) {
                setShowSuccess(true);
            } else {
                setSelectedFile(null);
                setShowSuccess(false);
            }
            setError('');
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    }, [open, showReplace]);



    const validateFile = (file) => {
        if (!ACCEPTED_TYPES.includes(file.type)) {
            setError('Invalid file type. Only .mp4 and .mov are allowed.');
            setSelectedFile(null);
            setShowSuccess(false);
            return false;
        }
        if (file.size > MAX_SIZE) {
            setError('File size exceeds 200MB limit.');
            setSelectedFile(null);
            setShowSuccess(false);
            return false;
        }
        setError('');
        return true;
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files && e.dataTransfer.files[0];
        if (file && validateFile(file)) {
            setSelectedFile(file);
            setShowSuccess(true);
        }
    };

    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            if (validateFile(file)) {
                setSelectedFile(file);
                setShowSuccess(true);
            } else {
                e.target.value = '';
                setShowSuccess(false);
            }
        }
    };

    const handleReplace = () => {
        setSelectedFile(null);
        setShowSuccess(false);
        setError('');
        fileInputRef.current.value = '';
    };

    const handleSave = () => {
        if (selectedFile) {
            onSave(selectedFile);
        }
    };

    if (!open) return null;

    return (
        <div className="upload-modal-overlay">
            <div className="upload-modal">
               {loader && (
                <div className="loader-overlay" style={{ zIndex: 1000 }}>
                    <FadeLoader />
                </div>
            )}
                <h3 className="upload-title">Upload Owner Recording</h3>
                <div
                    className="upload-dropzone"
                    onDrop={handleDrop}
                    onDragOver={(e) => e.preventDefault()}
                >
                    <input
                        type="file"
                        accept=".mp4,.mov"
                        style={{ display: 'none' }}
                        ref={fileInputRef}
                        onChange={handleFileChange}
                    />
                    {!showSuccess ? (
                        <div>
                            <div>Drag &amp; drop a video here</div>
                            <div className="upload-or">or</div>
                            <button className="upload-link" type="button" onClick={handleBrowseClick}>
                                Click
                            </button>
                            <span> to browse your files</span>
                            <div className="upload-info">
                                File type allowed: <b>.mp4, .mov</b> &nbsp; Max Size: <b>200MB</b>
                            </div>
                            {error && (
                                <div className="upload-error" style={{ color: 'red', marginTop: '10px' }}>
                                    {error}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div>
                            <div style={{ fontWeight: 500, fontSize: 18, marginBottom: 10 }}>
                                Video Upload Successfully!
                            </div>
                            <div>
                                Filename: {selectedFile?.name || existingFile?.name || "Unknown"}
                            </div>
                            {(selectedFile?.size || existingFile?.size) ? (
                                <div>
                                    Size: {((selectedFile?.size || existingFile?.size) / (1024 * 1024)).toFixed(1)} MB
                                </div>
                            ) : null}
                            <button
                                className="upload-link"
                                type="button"
                                style={{ marginTop: 12 }}
                                onClick={handleReplace}
                            >
                                Replace Video
                            </button>
                        </div>

                    )}
                </div>
                <div className="upload-actions">
                    <button className="upload-cancel" onClick={onClose}>Cancel</button>
                    <button
                        className="upload-save"
                        onClick={handleSave}
                        disabled={!selectedFile || !!error}
                    >
                        Save &amp; Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UploadOwnerRecording;